import { DocumentS } from '../Templates/Documents/DocumentS';
import { FormSubmission, PortalShare } from '../Types/ShareT';
import { ajaxActions } from './AjaxActions';
import { ToastS } from './ToastS';

const BASE_URL = process.env.REACT_APP_SHARE_SERVICE_URL;

const patchFormSubmission = async (id: string, patch: Partial<FormSubmission>): Promise<FormSubmission | null> => {
  const resp = await ajaxActions.patch(`${BASE_URL}/formSubmissions/${id}`, patch);
  if (resp.ok) {
    return resp.json();
  }
  ToastS.generalError();
  return null;
};

const changeResourceIndex = async (shareId: string, oldIndex: number, newIndex: number) => {
  const resp = await ajaxActions.patch(
    `${BASE_URL}/shares/${shareId}/resources?fromIndex=${oldIndex}&newIndex=${newIndex}`,
    {},
  );
  if (resp.ok) {
    return resp.json();
  }
  ToastS.generalError();
  return null;
};

const getPortalLink = (share: PortalShare): string =>
  `${process.env.REACT_APP_PORTAL_SERVICE_URL}/login?shareId=${share.id}&key=${share.password}`;

const isContractSigned = async (contractId: number): Promise<boolean> => {
  const submissions = await getSubmittedFormSubmissions(contractId.toString(), 'contracts');
  return submissions.length !== 0;
};

const getSubmittedFormSubmissions = async (entityId: string, entityType: string): Promise<FormSubmission[]> => {
  const params = new URLSearchParams({ entityId, entityType });
  const res = await ajaxActions.get(`${BASE_URL}/formSubmissions?${params.toString()}`);
  if (res.ok) {
    return res.json();
  }
  return [];
};

const isDocumentAttachedToSignedContract = async (documentId: number): Promise<boolean> => {
  const contracts = await DocumentS.filterContracts(documentId);
  if (contracts.length === 0) {
    return false;
  }
  for (const contract of contracts) {
    // eslint-disable-next-line no-await-in-loop
    const signed = await isContractSigned(contract.id);
    if (signed) return true;
  }
  return false;
};

const deleteAllShares = async () => {
  const ok = await ajaxActions.del(`${BASE_URL}/shares/all`);
  if (ok) {
    ToastS.info('all-shares-removed', 'All shares removed');
    return;
  }
  ToastS.generalError();
};

// eslint-disable-next-line import/prefer-default-export
export const ShareS = {
  patchFormSubmission,
  changeResourceIndex,
  getPortalLink,
  isContractSigned,
  isDocumentAttachedToSignedContract,
  deleteAllShares,
};
